import * as types from './types';

export const setBookingConfig = (bookingConfig) => {
	return { type: types.SET_BOOKING_CONFIG, bookingConfig };
};

export const controlActions = {
	setBookingConfig
};
